import { css } from '@emotion/react'
import styled from '@emotion/styled'

const baseStyles = ({ theme }) => css`
  label: document;

  margin-bottom: ${theme.spacings.giga};
`

const labelStyles = ({ theme }) => css`
  label: document__label;

  font-size: ${theme.typography.subHeadings.mega.fontSize};
  font-weight: ${theme.font.weight.bold};
  line-height: ${theme.typography.subHeadings.mega.lineHeight};

  margin-left: ${theme.spacings.mega};
`

const messageStyles = ({ theme }) => css`
  label: document__message;

  display: block;

  margin-left: ${theme.spacings.mega};
  margin-top: ${theme.spacings.byte};
  margin-bottom: ${theme.spacings.kilo};

  font-size: ${theme.typography.subHeadings.kilo.fontSize};
`

const hasErrorStyles = ({ theme, hasError = false }) =>
  hasError &&
  css`
    label: document__message--error;

    color: ${theme.colors.danger};
  `

const isSuccessStyles = ({ theme, isSuccess = false }) =>
  isSuccess &&
  css`
    label: document__message--success;

    color: ${theme.colors.success};
  `

const defaultMessageStyles = ({ theme, hasError = false, isSuccess = false }) =>
  !hasError &&
  !isSuccess &&
  css`
    label: document__message--default;

    color: ${theme.colors.p500};
  `

export const Wrapper = styled('div')(baseStyles)
export const Label = styled('label')(labelStyles)
export const Message = styled('span')(
  messageStyles,
  hasErrorStyles,
  isSuccessStyles,
  defaultMessageStyles
)
